import { render } from "./Feedback.vue?vue&type=template&id=6aa9f174&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=6aa9f174&scoped=true&lang=css"
import "./Feedback.vue?vue&type=style&index=1&id=6aa9f174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa9f174"]])

export default __exports__